// ----------------------------
// Created by Bulletproof Games
//            2016
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Dims the screen
//

screenDimObjectManager = {};
screenDimObjectManager.objects = [];

screenDimObjectManager.create = function (json) {
  var screenDimObject = new PIXI.Container();

  var _landscapeDefaultParams;
  var _landscapeMobileParams;
  var _portraitDefaultParams;
  var _alpha = 0.8;

  screenDimObject.onOrientationChange = function () {
    if (typeof json.fullscreen === "undefined" || json.fullscreen) {
      if (json.oversize) {
        screenDimObject.resize(
          -100,
          -100,
          systemData.LOGICAL_SCREEN_WIDTH + 200,
          systemData.LOGICAL_SCREEN_HEIGHT + 200,
          _alpha
        );
      } else {
        screenDimObject.resize(
          0,
          0,
          systemData.LOGICAL_SCREEN_WIDTH,
          systemData.LOGICAL_SCREEN_HEIGHT,
          _alpha
        );
      }
    } else {
      switch (layoutController.getCurrentLayout()) {
        case "landscape_default":
          {
            screenDimObject.resize(
              _landscapeDefaultParams.x,
              _landscapeDefaultParams.y,
              _landscapeDefaultParams.width,
              _landscapeDefaultParams.height,
              _alpha
            );
          }
          break;
        case "portrait_mobile":
        case "portrait_default":
          {
            screenDimObject.resize(
              _portraitDefaultParams.x,
              _portraitDefaultParams.y,
              _portraitDefaultParams.width,
              _portraitDefaultParams.height,
              _alpha
            );
          }
          break;

        case "landscape_mobile":
          {
            screenDimObject.resize(
              _landscapeMobileParams.x,
              _landscapeMobileParams.y,
              _landscapeMobileParams.width,
              _landscapeMobileParams.height,
              _alpha
            );
          }
          break;
      }
    }
  };

  screenDimObject.init = function () {
    if (typeof json.fullscreen === "undefined" || json.fullscreen) {
      _landscapeDefaultParams = {
        x: 0,
        y: 0,
        width: systemData.LOGICAL_SCREEN_WIDTH,
        height: systemData.LOGICAL_SCREEN_HEIGHT,
      };
      _landscapeMobileParams = {
        x: 0,
        y: 0,
        width: systemData.LOGICAL_SCREEN_WIDTH,
        height: systemData.LOGICAL_SCREEN_HEIGHT,
      };
      _portraitDefaultParams = {
        x: 0,
        y: 0,
        width: systemData.LOGICAL_SCREEN_WIDTH,
        height: systemData.LOGICAL_SCREEN_HEIGHT,
      };
    } else {
      _landscapeDefaultParams = {
        x: json.landscape_default.position.x,
        y: json.landscape_default.position.y,
        width:
          json.landscape_default.position.width /
          resourceManager.selectedAssetResolution.scaleFactor,
        height:
          json.landscape_default.position.height /
          resourceManager.selectedAssetResolution.scaleFactor,
      };
      _landscapeMobileParams = {
        x: json.landscape_mobile.position.x,
        y: json.landscape_mobile.position.y,
        width:
          json.landscape_mobile.position.width /
          resourceManager.selectedAssetResolution.scaleFactor,
        height:
          json.landscape_mobile.position.height /
          resourceManager.selectedAssetResolution.scaleFactor,
      };
      _portraitDefaultParams = {
        x: json.portrait_default.position.x,
        y: json.portrait_default.position.y,
        width:
          json.portrait_default.position.width /
          resourceManager.selectedAssetResolution.scaleFactor,
        height:
          json.portrait_default.position.height /
          resourceManager.selectedAssetResolution.scaleFactor,
      };
    }
    if (json.alpha !== undefined) {
      _alpha = json.alpha;
    }
    screenDimObject.onOrientationChange();
  };

  screenDimObject.resize = function (x, y, width, height, alpha) {
    if (typeof screenDimObject.graphics !== "undefined") {
      screenDimObject.graphics.clear();
      screenDimObject.graphics.beginFill(0x000000, alpha);
      screenDimObject.graphics.drawRect(x, y, width, height);
      screenDimObject.graphics.endFill();
    }
  };

  screenDimObject.show = function (show, a) {
    if (typeof show === "undefined") {
      show = true;
    }
    let alpha = _alpha;
    if (a !== undefined) {
      alpha = a;
    }
    screenDimObject.alpha = alpha;
    screenDimObject.visible = show;
  };

  screenDimObject.setAlpha = function (alpha) {
    screenDimObject.alpha = alpha;
  };

  screenDimObject.screenChanged = function () {
    screenDimObject.onOrientationChange();
  };

  Reflex.registerEventHandler("resize", screenDimObject.screenChanged);
  Reflex.registerEventHandler(
    "orientationChange",
    screenDimObject.onOrientationChange
  );
  messageBus.subscribe(
    "common:FullyLoaded",
    screenDimObject.onOrientationChange
  );

  screenDimObjectManager.objects.push(screenDimObject);

  return screenDimObject;
};

screenDimObjectManager.initialise = function (json, dimObject) {
  dimObject.parent.visible = true;

  dimObject.visible = false;

  dimObject.graphics = new PIXI.Graphics();
  dimObject.addChild(dimObject.graphics);

  dimObject.init();
};

screenDimObjectManager.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "screenDimObject",
  screenDimObjectManager.create,
  screenDimObjectManager.initialise,
  screenDimObjectManager.getFilesRequired
);
